import { Box } from "@mui/material"
import {
  Gear,
  IconProps,
  Microphone,
  MicrophoneSlash,
  VideoCamera,
} from "@phosphor-icons/react"
import { VideoCameraSlash } from "@phosphor-icons/react/dist/ssr"
import React from "react"
import { useAppContext } from "../../app/Context"

interface MediaControlsBarProps {
  isMicEnabled: boolean
  isCameraEnabled: boolean
  toggleMicrophone: () => void
  toggleCamera: () => void
  onSettingsClick: () => void
  bottom?: string
}

const containerSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 60,
  height: 60,
  borderRadius: "50%",
  cursor: "pointer",
  backgroundColor: "var(--call-chip-bg)",
  "&:hover": {
    backgroundColor: "var(--call-chip-bg-hover)",
  },
}

const iconProps: IconProps = {
  size: 32,
}

export const MediaControlsBar: React.FC<MediaControlsBarProps> = ({
  isMicEnabled,
  isCameraEnabled,
  toggleMicrophone,
  toggleCamera,
  onSettingsClick,
  bottom = "5%",
}) => {
  const context = useAppContext()
  const stream = context.stream

  if (!stream) return null

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
        position: "absolute",
        bottom: bottom,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1000,
      }}
    >
      <Box
        onClick={toggleCamera}
        sx={{
          ...containerSx,
          backgroundColor: !isCameraEnabled ? "black" : "var(--call-chip-bg)",
        }}
      >
        {isCameraEnabled ? (
          <VideoCamera
            {...iconProps}
            color="var(--color-foreground-fg-white)"
          />
        ) : (
          <VideoCameraSlash
            {...iconProps}
            color="var(--color-background-bg-brand-primary)"
          />
        )}
      </Box>
      <Box
        onClick={toggleMicrophone}
        sx={{
          ...containerSx,
          backgroundColor: !isMicEnabled ? "black" : "var(--call-chip-bg)",
        }}
      >
        {isMicEnabled ? (
          <Microphone {...iconProps} color="var(--color-foreground-fg-white)" />
        ) : (
          <MicrophoneSlash
            {...iconProps}
            color="var(--color-background-bg-brand-primary)"
          />
        )}
      </Box>
      <Box onClick={onSettingsClick} sx={containerSx}>
        <Gear {...iconProps} color="var(--color-foreground-fg-white)" />
      </Box>
    </Box>
  )
}
